import { KDSPermission, RoutePaths } from '../enums';

// The page each view permission opens. Edit and approval permissions open no page of their own.
const LANDING: Partial<Record<KDSPermission, RoutePaths>> = {
  [KDSPermission.VIEW_COMPONENTS_CHECK]: RoutePaths.componentsCheck,
  [KDSPermission.VIEW_PORTIONING_DISPLAY]: RoutePaths.portioningDisplay,
  [KDSPermission.VIEW_MEALS_STATUS]: RoutePaths.mealsStatus,
  [KDSPermission.VIEW_WASTAGE_TRACKING]: RoutePaths.wastageTracking,
  [KDSPermission.VIEW_QUALITY_TRACKING]: RoutePaths.qualityTracking,
  [KDSPermission.VIEW_SHORTAGE_REPORTING]: RoutePaths.shortageReporting,
  [KDSPermission.VIEW_SHORTAGE_DISPLAY]: RoutePaths.shortageDisplay,
  [KDSPermission.VIEW_ASSEMBLY_CHECK]: RoutePaths.assemblyCheck,
  [KDSPermission.VIEW_PRE_DISPATCH_CHECK]: RoutePaths.preDispatchCheck,
  [KDSPermission.VIEW_RECIPE_GUIDEBOOK]: RoutePaths.recipeGuideBook,
  [KDSPermission.VIEW_LOCK_TIME_CHANGES]: RoutePaths.lockTimeChanges,
  [KDSPermission.VIEW_PRODUCTION_CONTROL]: RoutePaths.productionControl,
  [KDSPermission.VIEW_LOGISTICS_CHANGES]: RoutePaths.logisticsChanges,
  [KDSPermission.VIEW_DRIVER_DISPATCH]: RoutePaths.driverDispatch,
  [KDSPermission.VIEW_CUSTOMER_COMPLAINTS]: RoutePaths.customerComplaints,
  [KDSPermission.VIEW_FILE_MANAGEMENT]: RoutePaths.fileManagement,
  [KDSPermission.VIEW_SPECIAL_REQUEST]: RoutePaths.specialRequest,
  [KDSPermission.VIEW_QUALITY_METRICS]: RoutePaths.qualityMetrics,
  [KDSPermission.VIEW_TOP_CONTROL]: RoutePaths.topControl,
  [KDSPermission.VIEW_PRODUCTIVITY_METRICS]: RoutePaths.productivityMetrics,
  [KDSPermission.VIEW_LEFTOVER_METRICS]: RoutePaths.leftoverMetrics,
  [KDSPermission.VIEW_COMPONENTS_PORTIONING]: RoutePaths.componentsPortioning,
  [KDSPermission.VIEW_YIELD_TRACKING]: RoutePaths.yieldTracking,
  [KDSPermission.VIEW_KITCHEN_STAFF]: RoutePaths.kitchenStaff,
  [KDSPermission.VIEW_LABOR_PLANNING]: RoutePaths.staffTracking,
  [KDSPermission.VIEW_WEIGHT_TRACKING]: RoutePaths.weightTracking,
  [KDSPermission.VIEW_KITCHEN_FLOOR]: RoutePaths.controlTower,
  [KDSPermission.VIEW_PRODUCTION_PLAN]: RoutePaths.productionPlan,
  [KDSPermission.VIEW_BATCH_TRACKING]: RoutePaths.batchTracking
};

// The page of the first permission, in the account's own order, that opens one.
export const getFirstPermittedRoute = (permissions: KDSPermission[]): string | undefined => {
  for (const permission of permissions) {
    const route = LANDING[permission];
    if (route !== undefined) {
      return route;
    }
  }
  return undefined;
};
